interface Locale {
  iso3166: string;
  icu: string;
}

const locales: Locale[] = [
  {
    iso3166: "AR",
    icu: "es-AR",
  },
  {
    iso3166: "CL",
    icu: "es-CL",
  },
  {
    iso3166: "CO",
    icu: "es-CO",
  },
  {
    iso3166: "BR",
    icu: "pt-BR",
  },
  {
    iso3166: "BR",
    icu: "pt-KR",
  },
];

/*
  Transcode locale string from one format to another.
*/
export default function transcodeLocale(
  locale: string,
  fromFormat: "iso3166" | "icu",
  toFormat: "iso3166" | "icu",
) {
  const localeObject = locales.find((item) => {
    return item[fromFormat] === locale;
  });

  return localeObject ? localeObject[toFormat] : "UNKNOWN";
}
